import ICCertificateFill from "@Assets/icons/certificate-fill.svg";
import { STATUS_CERTIFICATE } from "@Constants/status-certificate";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useGetDailyVisitor from "@Hooks/queries/useGetDailyVisitor";
import useGetPendingCertificate from "@Hooks/queries/useGetPendingCertificate";
import reduce from "lodash/reduce";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";
import { useHistory } from "react-router-dom";
import "./AdminDashboard.css";
import CardDashboard from "./Components/CardDashboard";
import React from "react";

const AdminDashboard = () => {
  const history = useHistory();

  const { data: dailyVisitor, isLoading: isLoadingDailyVisitor } =
    useGetDailyVisitor();
  const {
    data: dataPendingCertificate,
    isLoading: isLoadingPendingCertificate,
  } = useGetPendingCertificate();

  const isLoading = isLoadingDailyVisitor || isLoadingPendingCertificate;

  const dailyVisitorDate = moment(dailyVisitor?.date).format("DD-MM-YYYY");

  const resultPatientToday = reduce(
    dailyVisitor?.visitorByShift,
    (prev, { count }) => prev + count,
    0,
  );

  return (
    <>
            <LoadingOverlay active={isLoading} spinner text="Memuat data...">
        <div className="content-section">
          <h1 className="dashboard-date ml-5">
            Tanggal Hari Ini : {dailyVisitorDate}
          </h1>
          <h2 className="dashboard-date ml-5">
            Total Pasien Hari Ini : {resultPatientToday || 0}
          </h2>

          <div className="dashboard-card text-center">
            {dailyVisitor?.date !== null && (
              <>
                {dailyVisitor?.visitorByShift.map((res, idx) => (
                  <CardDashboard
                    key={idx}
                    icon={
                      <FontAwesomeIcon icon={faUsers} className="card-icon" />
                    }
                    title={`Total Pasien ${res?.name || ""} (Orang)`}
                    count={res.count}
                  />
                ))}
              </>
            )}

            <CardDashboard
              onClick={() =>
                history.push({
                  pathname: "/request-certificate",
                  search: `?status=${STATUS_CERTIFICATE.WAITING_FOR_SIGNING}`,
                })
              }
              icon={
                <img
                  src={ICCertificateFill}
                  alt="certificate-fill.svg"
                  className="card-icon"
                />
              }
              title="Pending Certificate"
              count={dataPendingCertificate?.count || 0}
            />
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
};

export default AdminDashboard;
